import { useState, useContext } from "react";
import BuilderContext from "../../../store/BuilderContext";
import BackgroundColor from "./StylingComponents/BackgroundColor";
import Border from "./StylingComponents/Border";
import BorderRadius from "./StylingComponents/BorderRadius";
import Color from "./StylingComponents/Color";
import Font from "./StylingComponents/Font";
import Height from "./StylingComponents/Height";
import DynamicStylingTool from "./DynamicStylingTool/DynamicStylingTool";


const SectionProgressBarWidget = (props) => {

  console.log("SectionProgressBarWidget props", props);
  
  // const blockId = props?.blockId;
  // console.log("SectionWidget blockId", blockId);

  const builderCtx = useContext(BuilderContext);
  const { contentBlocks, updateContentBlocks, currentContentBlock, updateCurrentBlock } = builderCtx;


  console.log("currentContentBlock", currentContentBlock);
  
  const currentBlock = contentBlocks?.find(block => block.contentType === "SectionProgressBar");
  const blockId = contentBlocks?.find(block => block.contentType === "SectionProgressBar")?.id;
  const currentBlockStyles = currentBlock?.styling;
  console.log(currentBlockStyles);
  console.log("currentBlock", currentBlock);

  return (
    <div>
      {/* <p>Section Progress Bar Widget</p> */}
      {/* <Color blockId={blockId} />
      <BackgroundColor blockId={blockId} />
      <Height blockId={blockId} />
      <Border blockId={blockId} />
      <BorderRadius blockId={blockId} /> */}
      
      <DynamicStylingTool/>
    </div>
  );
}

export default SectionProgressBarWidget;

